<template lang="pug">
  .media-picker
    Dialog(
      eager
      persistent
      v-model="dialog.isActive.value"
      max-width="80%"
      :title="$t($lang.media.ADD_MEDIA)"
      @close="close"
    )
      template(v-slot:dialog-content)
        v-row.mt-5.mx-1
          v-col(v-for="(mediaType, index) in mediaTypesToPick" :key="index")
            .media-picker-pick-box__button.text-center.pa-md-16(@click="pickType(mediaType.select)"
              :data-test-id="MediaListAutomatedTestIds.MEDIA_LIST_DRAG_DROP_UPLOAD_FILE")
              v-icon.media-picker-pick-box__icon.mb-5.d-block(color="primary" :class="mediaType.class") {{ mediaType.icon }}
              span.media-picker-pick-box__title.font-weight-regular.text-h5.text-center.d-block
                | {{ $t($lang[mediaType.langPath][mediaType.langKey]) }}
    AgencyPhotoPicker(ref="agencyPhotoPickerRef" :multiple="multiple" :items-per-page="20"
      :showAddPhotoInformation="showAddPhotoInformation")
</template>

<script>
import { ref } from 'vue';
import { hashCode } from '@piri/utils';
import {
  blobToFile, downloadFile, getFileName,
} from '@/helpers/misc';
import { useDialog } from '@/helpers/misc/dialog';
import { useOverlaySpinnerLoading } from '@/helpers/loadings';
import AgencyPhotoPicker from '../../../agency/AgencyPhotoPicker.vue';
import { agencyPhotoPickTypes } from '../../../agency/constants';
import { Dialog } from '../../dialog';
import { MediaListAutomatedTestIds } from '../dataTest';

export default {
  name: 'MediaPicker',
  components: {
    Dialog,
    AgencyPhotoPicker,
  },
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    showAddPhotoInformation: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onSelectFile', 'onFilesSelected'],
  setup(props, { emit }) {
    const agencyPhotoPickerRef = ref(null);
    const loadingHashCode = hashCode('mediaPickerLoading');

    const dialog = useDialog();

    const pick = () => {
      dialog.open();
    };

    const close = () => {
      dialog.close();
    };

    const selectFile = () => {
      emit('onSelectFile');
    };

    const downloadAndEmitPhotos = type => async () => {
      const result = await agencyPhotoPickerRef.value.pick(type);
      useOverlaySpinnerLoading().show(loadingHashCode);

      await Promise.all(result.files.map(async photo => {
        const blob = await downloadFile(`${process.env.VUE_APP_MEDIA_SERVER_URL}${photo.path}`);
        const fileName = getFileName(photo.path);
        photo.file = blobToFile(blob, fileName);
      }));

      useOverlaySpinnerLoading().hide(loadingHashCode);

      emit('onFilesSelected', result);
    };

    const pickType = selectFn => {
      selectFn();
      close();
    };

    const mediaTypesToPick = [
      {
        langPath: 'file',
        langKey: 'UPLOAD_FILE',
        icon: 'file_upload',
        select: selectFile,
        class: 'uploadfileClass',
      },
      /*      {
        langPath: 'agency',
        langKey: 'ARCHIVE',
        icon: 'inventory',
        select: downloadAndEmitPhotos(agencyPhotoPickTypes.ARCHIVE),
      }, */
      {
        langPath: 'agency',
        langKey: 'AGENCY',
        icon: 'collections_bookmark',
        select: downloadAndEmitPhotos(agencyPhotoPickTypes.AGENCY),
      },
    ];

    return {
      agencyPhotoPickerRef,
      dialog,
      close,
      pick,
      pickType,
      MediaListAutomatedTestIds,
      mediaTypesToPick,
    };
  },
};
</script>

<style lang="scss">
.media-picker {
  $this: &;

  &-pick-box {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__button {
      background-color: #f1f1f133;
      cursor: pointer;
    }

    &__icon {
      font-size: 4em !important;
    }
  }
}
</style>
